import { Spin } from 'antd';
import styled from 'styled-components';

import { EverysetLogo } from '@assets/img';
import SaaSLogo from '@assets/img/SaaSLogo';
import { useClientEnvironment } from '@hooks/clientEnvironment';

export const SplashScreen = (): JSX.Element => {
  const { data: clientEnvironment, isLoading: isClientEnvironmentLoading } = useClientEnvironment();
  const { isEveryset } = clientEnvironment || {};

  if (isClientEnvironmentLoading) {
    return (
      <StyledContainer>
        <StyledSpin size='large' />
      </StyledContainer>
    );
  }

  return (
    <StyledContainer>
      {(isEveryset) ? <EverysetLogo width='20vw' /> : <SaaSLogo />}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  height: 100vh;
  display: grid;
  place-content: center;
`;

const StyledSpin = styled(Spin)`
  .ant-spin-dot {
    font-size: 60px;
    .ant-spin-dot-item {
      width: 24px;
      height: 24px;
    }
  }
`;
